import FormTitle from '@core/components/FormTitle';
import { AnexoDropzone } from 'app/components/Anexo';
import { compraApi } from 'app/services/api/compraApi';
import React from 'react';

const emptyFunction = () => {};

const CompraAnexo = ({ onAdd = emptyFunction, onRemove = emptyFunction, values }) => {
  const handleUpload = async (e) => {
    const files = e.target.value || [];

    files.forEach(async (file) => {
      const formData = new FormData();
      formData.append('arquivo', file);
      const res = await compraApi().enviarAnexo(formData);

      onAdd(res.data);
    });
  };

  return (
    <>
      <div className="mt-24" />
      <FormTitle title="Anexo de documentos" />
      <AnexoDropzone
        onDropFile={handleUpload}
        files={values}
        onRemove={onRemove}
        linkDownload="/api/v1/backend/compra/anexo/download"
      />
    </>
  );
};

export default CompraAnexo;
